import { DocsInfoCard } from '../types';

export const GETTING_STARTED_TITLE = 'Getting Started with DX Portal and APIs';

export const GETTING_STARTED_INTRO =
  'Welcome to the Digital Realty DX Portal! This comprehensive guide will walk you through everything you need to know to start integrating with our APIs and accessing DLR digital services.';

export const GETTING_STARTED_CARDS: DocsInfoCard[] = [
  {
    title: "What You'll Learn",
    description: "By the end of this guide, you'll be able to:",
    items: [
      'Access your API credentials from the DX Portal',
      'Authenticate and obtain access tokens',
      'Make your first successful API request',
      'Understand best practices for API integration',
    ],
    background: 'white',
  },
  {
    title: 'Prerequisites',
    description: 'Before you begin, ensure you have:',
    items: [
      "Access to the DX Portal (if you're reading this, you likely already have access!)",
      'Basic understanding of REST APIs and HTTP requests',
    ],
    background: 'transparent',
  },
];
